<ion-nav #nav [animated]="animateNav" [root]="navRoot" [rootParams]="navRootProps"></ion-nav>
